module.exports = __webpack_public_path__ + "static/media/image9.87348d22.png";